module.exports = __webpack_public_path__ + "img/crls_avatar.0edfca36.png";